<template>
  <div
    data-qa="appointment_preloader"
    class="d-flex flex-column align-center justify-center h-100"
  >
    <div class="my-auto">
      <v-progress-circular
        size="61"
        width="3"
        indeterminate
        class="primary--text d-block mb-6 mx-auto"
      />
      <div
        class="text-body-1 text--text text-center"
        data-qa="appointment_preloader_progress_text"
      >
        <template v-if="appointmentPlaceTypes.isTelemed || appointmentPlaceTypes.isTelemedMedtochka">
          {{ $t('Открываем ваш личный кабинет — МедТочку', options) }}
        </template>
        <template v-else>
          {{ $t('Записываем на прием...', options) }}
        </template>
      </div>
    </div>
    <div
      class="text-body-2 text-info--text text-center w-100"
      :class="{ 'mb-6': !isMobile }"
      data-qa="appointment_preloader_help"
    >
      {{ $t('Если возникли вопросы, звоните', options) }}
      <br>
      <!-- Табуляция специально таким образом расставлена -->
      <!-- Чтобы подчеркивание ссылки не выходило за пределы слова -->
      <a
        href="tel:88007073129"
        class="text-body-2 text-info--text"
        data-qa="appointment_preloader_phone"
      >8 (800) 707-31-29</a>
      {{ $t('— поможем разобраться', options) }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useAppointmentDataStore } from 'www/vue_components/common/AppointmentPage/stores'

export default {
  name: 'AppointmentPreloader',
  data: vm => ({
    isMobile: window.MOBILE_VERSION,
    options: { ns: vm.$i18next.language },
  }),
  computed: {
    ...mapState(useAppointmentDataStore, [
      'appointmentPlaceTypes',
    ]),
  },
}
</script>
